import { NavLink } from "react-router-dom";
import JobZImage from "../../../../../common/jobz-img";
import { getJobDetailUrl } from "../../../../../../globals/constants";
import { publicUser } from "../../../../../../globals/route-names";

function SectionAvailableJobsList({ jobs = [] }) {
    if (!jobs || jobs.length === 0) return null;

    const formatDate = (value) => {
        if (!value) return "Recently";
        return new Date(value).toLocaleDateString();
    };

    const salary = (job) => {
        if (job.salary_min && job.salary_max) return `₹${Number(job.salary_min).toLocaleString("en-IN")} - ₹${Number(job.salary_max).toLocaleString("en-IN")}`;
        if (job.salary_min) return `₹${Number(job.salary_min).toLocaleString("en-IN")}`;
        return "Salary disclosed";
    };

    return (
        <>
            <h4 className="twm-s-title">Available Jobs</h4>
            <div className="twm-jobs-list-wrap">
                <ul>
                    {jobs.map((job, index) => (
                        <li key={job.id}>
                            <div className="twm-jobs-list-style1 mb-5">
                                <div className="twm-media">
                                    <JobZImage src={job.company_logo_url || job.job_image_url || `images/jobs-company/pic${(index % 5) + 1}.jpg`} alt={job.company_name || job.title} />
                                </div>
                                <div className="twm-mid-content">
                                    <NavLink to={getJobDetailUrl(job)} className="twm-job-title">
                                        <h4>{job.title}<span className="twm-job-post-duration">/ {formatDate(job.created_at)}</span></h4>
                                    </NavLink>
                                    <p className="twm-job-address">{job.location}</p>
                                    <div className="twm-job-websites site-text-primary">{job.company_name}</div>
                                </div>
                                <div className="twm-right-content">
                                    <div className="twm-jobs-category green"><span className="twm-bg-green">{job.job_type}</span></div>
                                    <div className="twm-jobs-amount">{salary(job)} <span>/ {job.salary_period || "Month"}</span></div>
                                    <NavLink to={getJobDetailUrl(job)} className="twm-jobs-browse site-text-primary">Browse Job</NavLink>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    )
}

export default SectionAvailableJobsList;